export type DeadlineStatus = 'done' | 'critical' | 'soon' | 'clear'

export interface StatusStyle {
  label: string
  rail: string
  surface: string
  border: string
  text: string
  dot: string
}

export const statusStyles: Record<DeadlineStatus, StatusStyle> = {
  clear: {
    label: 'More than a week out',
    rail: 'bg-evergreen',
    surface: 'bg-evergreen/[0.06]',
    border: 'border-evergreen/35',
    text: 'text-evergreen',
    dot: 'bg-evergreen',
  },
  soon: {
    label: 'Within a week',
    rail: 'bg-campaign',
    surface: 'bg-campaign/[0.07]',
    border: 'border-campaign/40',
    text: 'text-campaign',
    dot: 'bg-campaign',
  },
  critical: {
    label: 'Within 48 hours',
    rail: 'bg-alert',
    surface: 'bg-alert/[0.07]',
    border: 'border-alert/45',
    text: 'text-alert',
    dot: 'bg-alert',
  },
  done: {
    label: 'Completed',
    rail: 'bg-ink-500',
    surface: 'bg-ink-800/50',
    border: 'border-ink-600',
    text: 'text-faint',
    dot: 'bg-ink-500',
  },
}

const HOUR = 3600000
const PUBLISH_HOUR = 'T09:00:00'

export function hoursUntil(dateIso: string, now: Date = new Date()): number {
  return (new Date(`${dateIso}${PUBLISH_HOUR}`).getTime() - now.getTime()) / HOUR
}

export function getStatus(dateIso: string, isDone: boolean, now: Date = new Date()): DeadlineStatus {
  if (isDone) return 'done'
  const hours = hoursUntil(dateIso, now)
  if (hours <= 48) return 'critical'
  if (hours <= 24 * 7) return 'soon'
  return 'clear'
}

export function countdownLabel(dateIso: string, now: Date = new Date()): string {
  const hours = hoursUntil(dateIso, now)
  if (hours < -24) return `${Math.round(Math.abs(hours) / 24)}d overdue`
  if (hours < 0) return 'Overdue'
  if (hours < 1) return 'Due now'
  if (hours < 24) return `In ${Math.round(hours)}h`
  return `In ${Math.round(hours / 24)}d`
}
